import { Box, Divider, List, ListItem } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { Link, Outlet } from 'react-router-dom';

import { PageWrapper } from './components/Branding.styles';

const ChildListItem = styled(ListItem)(({ theme: t }) => ({
  marginLeft: t.spacing(6),
}));

const DEMO_EMAIL = encodeURIComponent('someone@example.com');

export default function HomeLinks() {
  return (
    <PageWrapper>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: '2rem' }}>
        <List>
          <ListItem>
            <Link to="/pre-screening">Pre-Screening form (short)</Link>
          </ListItem>
          <ListItem>
            <Link to="/pre-screening?display=long">Pre-Screening form (long)</Link>
          </ListItem>
          <ChildListItem>
            <Link to="/pre-screening?cal=true">Nurse booking calendar</Link>
          </ChildListItem>
          <ChildListItem>
            <Link to={`/consult-eligible?email=${DEMO_EMAIL}&consultFlow=inc`}>Consult eligibility (entry, inc)</Link>
          </ChildListItem>
          <ChildListItem>
            <Link to={`/consult-eligible?email=${DEMO_EMAIL}&consultFlow=d2d`}>Consult eligibility (entry, d2d)</Link>
          </ChildListItem>
          <ChildListItem>
            <Link to={`/triage?email=${DEMO_EMAIL}`}>Triage form</Link>
          </ChildListItem>
          <ChildListItem>
            <Link to={`/direct-to-doctor?email=${DEMO_EMAIL}`}>D2D - Direct to Doctor</Link>
          </ChildListItem>

          <Divider sx={{ my: 4 }} />
          <ListItem>
            <Link to="/pre-consultation">Pre-Consultation form</Link>
          </ListItem>
          <Divider sx={{ my: 4 }} />
          <ListItem>
            <Link to="/medical-records-consent?data=123456">Medical Records Consent</Link>
          </ListItem>
        </List>
        <Outlet />
      </Box>
    </PageWrapper>
  );
}
